import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import SpinnerOverlay from '../shared/components/SpinnerOverlay/SpinnerOverlay';
export default function App() {
    return (_jsx(Suspense, { fallback: _jsx(SpinnerOverlay, {}), children: _jsx(RouterProvider, { router: router }) }));
}
